module.exports = __webpack_public_path__ + "img/stick_activites_visite_ferme.ccf77b2b.svg";